import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_CrisisPlan = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_CrisisPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <span className='eleHeader'>Client Medications</span>
                    <textarea id='txtClientMeds' name='txtClientMeds' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Brief History</span>
                    <textarea id='txtBriefHistory' name='txtBriefHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Crisis Triggers</span>
                    <textarea id='txtCrisisTriggers' name='txtCrisisTriggers' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Crisis Behaviors</span>
                    <textarea id='txtCrisisBx' name='txtCrisisBx' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Crisis Proactive Steps to prevent or decrease severity of crisis</span>
                    <textarea id='txtCrisisSteps' name='txtCrisisSteps' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Crisis Reactive Steps</span>
                    <textarea id='txtCrisisReactiveSteps' name='txtCrisisReactiveSteps' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Persons Involved</span>
                    <textarea id='txtPersonsInvolved' name='txtPersonsInvolved' className='add-only'></textarea>
                </p>


            </div>
        </form >

    )
}











